import { Component } from '@angular/core';
import { MazayaPlusService } from 'src/app/features/mazaya-plus/services';
import { MazayaPowerService } from '../../services/power-membership.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-power-cards',
  templateUrl: './view-power-cards.component.html',
  styleUrls: ['./view-power-cards.component.scss']
})
export class ViewPowerCardsComponent {
  lastTransaction: { type: string, transactionId: string } = null
  mazayaecardmain = null
  powerDetails: any[] = []
  exploreDetails: any[] = []

  constructor(
    private _mazayaPowerService: MazayaPowerService,) {


  }
  ngOnInit() {
    this.lastTransaction = JSON.parse(localStorage.getItem("lastTransaction"))
    this.getCards();

  }

  getBenefitsUrl(categoryId:number,subCategoryId:number,key:string): string {
    if (!categoryId) return '#'; // Prevent errors if categoryID is not set
  
    let token = localStorage.getItem('auth.token');
    if (token) {
      token = token.replace(/^"|"$/g, ''); 
    }
    const cacheBuster = new Date().getTime(); 
    return `${environment.benefitUrl}/card-details?key=${this.toCamelCase(key)}&categoryId=${categoryId}&subCategoryId=${subCategoryId}&token=${token}&_=${cacheBuster}`;
  }


   toCamelCase(str) {
    return str
      .toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, '');
  }
  getCards() {

    this._mazayaPowerService.getPowerExploreCards(this.lastTransaction.transactionId)
      .subscribe((res) => {
        this.mazayaecardmain = res.data.mazayaecardmain
        this.powerDetails = res.data.powerDetails
        this.exploreDetails = res.data.exploreDetails
      })
  }
  dateFormat(value: string): string {
    const date = moment(value);
    const formattedDate = date.format('DD/MM/YYYY');
    return formattedDate;
  }
}
